import getMediaElementsByUuids from 'editor/src/store/design/selector/getMediaElementsByUuids';

import { RootState } from 'editor/src/store';

import { FontStyles } from '../types';
import extractTextElementFontStyles from '../utils/extractTextElementFontStyles';

const getCurrentFontStylesProperty = <T extends keyof FontStyles>(state: RootState, key: T): FontStyles[T] => {
  const { selectedElementUuids } = state.editor;

  const textElement = getMediaElementsByUuids(state, selectedElementUuids)[0];
  if (textElement?.type === 'text') {
    return extractTextElementFontStyles(textElement)[key];
  }

  return state.fonts.defaultFontStyles[key];
};

export default getCurrentFontStylesProperty;
